import React, { useEffect, useState } from "react";
import { Clock } from "lucide-react";
import { calendarDaysUntil } from "../../lib/waitDuration";

/** "Today" / "Yesterday" / "N days ago" (future: "Tomorrow" / "In N days") from UK calendar days. */
export function elapsedDaysLabel(iso, now = Date.now()) {
  const d = calendarDaysUntil(iso, now);
  if (d === null || Number.isNaN(d)) return null;
  if (d === 0) return "Today";
  if (d === -1) return "Yesterday";
  if (d === 1) return "Tomorrow";
  return d < 0 ? `${-d} days ago` : `In ${d} days`;
}

export const fmtSaleAgreedDate = (iso) => new Date(iso)
  .toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" })
  .replace(/^(\d{1,2}) Sept /, "$1 Sep ");

// Re-renders shortly after each local midnight so the label rolls over daily.
function useDailyTick() {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const next = new Date(now);
    next.setHours(24, 0, 5, 0);
    const t = setTimeout(() => setNow(Date.now()), next.getTime() - Date.now());
    return () => clearTimeout(t);
  }, [now]);
  return now;
}

export const SaleAgreedElapsed = ({ iso, className = "", testid }) => {
  const now = useDailyTick();
  const label = iso ? elapsedDaysLabel(iso, now) : null;
  if (!label) return null;
  return (
    <span className={`inline-flex items-center gap-1 text-[11px] font-medium text-slate-500 whitespace-nowrap ${className}`} data-testid={testid}>
      <Clock size={11} strokeWidth={2.2} className="text-slate-400 shrink-0" aria-hidden />
      {label}
    </span>
  );
};
